import { HttpClient } from '@angular/common/http';
import { Component, NgZone, OnInit, ViewChild } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { DataService } from 'src/app/services/data.service';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { TranslateService } from '@ngx-translate/core';
import { finalize, map, tap } from 'rxjs/operators';
import { FirebaseStorageService } from 'src/app/services/firebase-storage.service';

import { MatSnackBar } from '@angular/material/snack-bar';
import { CustomPopupComponent } from '../dialogs/custom-popup/custom-popup.component';

@Component({
  selector: 'app-reportage-photos-details',
  templateUrl: './reportage-photos-details.component.html',
  styleUrls: ['./reportage-photos-details.component.sass']
})
export class ReportagePhotosDetailsComponent implements OnInit {
  students: any;
  email: string;
  password3: string;
  confirmPassword: string;
  studentsListSubs: Subscription;
  studentsList: Reportage[];
  reportagesListSubs: Subscription;
  reportages: any;
  stagesListSubs: Subscription;
  stages: any;
  gradesListSubs: Subscription;
  grades: any;
  // linesListSubs: Subscription;
  // lines: any;
  params: Reportage[];
  isList: boolean = true;
  isNew: boolean = true;
  private routeSub: Subscription;
  type_accept: string;
  studentForm: FormGroup;
  filterForm: FormGroup;
  pageEvent: PageEvent;
  modification_date: string;
  creation_date: string;
  readOnly: boolean = false;
  pageSize: number = 100;
  totalItems: any;
  selectedFiles: File;
  selectedSecondaryFiles: File;
  student_photo: any;
  displayedColumns: string[] = ['name', 'reportage', 'modification_date', 'actions'];
  dataSource: Reportage = null;
  disableClearFilterButton: boolean = true;


  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort, {}) sort: MatSort;

  showStudentPhotosProgressBar: boolean = true;
  showStudentPhotosProgressBar2: boolean = false;


  constructor(
    public dataService: DataService,
    private http: HttpClient,
    public firebase: AngularFireAuth,
    private ngZone: NgZone,
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    public translate: TranslateService,
    public firebaseStorageService: FirebaseStorageService,
    private snackbar: MatSnackBar
  ) { }

  public getStudentphotos() {

    this.studentsListSubs = this.dataService
      .getStudentphotos('')
      .subscribe(res => {
        this.students = res;
      },
        console.error
      );
  }

  public getReportages() {

    // Retrieve reportage filter from local storage.
    let reportageFilter = localStorage.getItem("reportage_filter");

    var params = {};
    params['page'] = 1
    params['size'] = 100000
    params['search'] = ''
    this.reportagesListSubs = this.dataService
      .getReportages(params)
      .subscribe(res => {
        this.reportages = res['items'];
        // this.reportages = [{ 'id': null, 'name': "" }].concat(this.reportages)

        if (reportageFilter && reportageFilter != "null") {
          let callTableUpdates = true;

          // We loop through reportages to make sure our filter matches existing reportage.
          res['items'].forEach(reportage => {
            // We update only if our filter matches an existing reportage ID, otherwise no filter is applied.
            if (reportage.id == reportageFilter) {
              this.filterForm.controls["reportages"].setValue(reportageFilter);
              callTableUpdates = false
              this.applyFilter(reportageFilter)
            }
          });

          if (callTableUpdates) {
            var params = {};
            params['page'] = 1
            params['size'] = this.pageSize
            params['search'] = '';
            params['role'] = '';
            this.updateReportagesTable(params);
            this.updatePaginator(params);
          }


        } else {
          this.dataSource = <any>[]
          this.showStudentPhotosProgressBar = false;
        }


        // this.studentForm.controls["reportages"].setValue(res['items'][0]['id'])
        // this.getStages(res['items'][0]['id'])
      },
        console.error
      );
  }



  public updatePaginator(params) {
    this.dataService.getTotalAllreportagesphoto(params).pipe(
      map((totalItems) => this.totalItems = totalItems)
    ).subscribe()
  }

  public updateReportagesTable(params) {
    this.filterForm.disable();
    this.dataService.getallreportagesphoto(params).pipe(
      map((tableData: Reportage) => this.dataSource = tableData)
    ).subscribe(() => {this.showStudentPhotosProgressBar = false; this.filterForm.enable();})
  }

  public clearFilterButtonState() {

    if (
      this.filterForm.controls["reportages"].value != '' ||
      this.filterForm.controls["stages"].value != '' ||
      this.filterForm.controls["grades"].value != ''
    ) {
      this.disableClearFilterButton = false;
    } else {
      this.disableClearFilterButton = true;
    }

  }


  ngOnInit() {
    this.type_accept = '.jpeg, .png, .jpg';
    this.dataService.getRole().subscribe(res => {
      if ((res != 'superadmin') && (res != 'admin')) {
        this.router.navigate(['/welcome']);
      }

    });
    this.studentForm = this.formBuilder.group({
      id: new FormControl(0, Validators.required),
      name: new FormControl('', Validators.required),
      reportage_id: new FormControl('', Validators.required),
      next_photoReportage: new FormControl('', Validators.required),
    });
    this.filterForm = this.formBuilder.group({
      reportages: new FormControl(null),
      stages: new FormControl(null),
      grades: new FormControl(null),
      // lines: new FormControl(null),
    });


    this.getReportages()
    var params = {};
    params['page'] = 1
    params['size'] = this.pageSize
    params['search'] = '';
    params['role'] = '';

    this.routeSub = this.route.params.subscribe(res => {
      if (res.id) {
        this.isList = false;

        if (res.id != 'new') {
          this.showStudentPhotosProgressBar2 = true;
          this.isNew = false;
          this.studentsListSubs = this.dataService
            .getReportagePhoto(res.id)
            .subscribe(res => {
              this.students = res;
              this.studentForm.controls["id"].setValue(this.students['id']);
              this.studentForm.controls["name"].setValue(this.students['name']);
              this.studentForm.controls["reportage_id"].setValue(this.students['reportage_id']);
              this.studentForm.controls["next_photoReportage"].setValue(this.students['next_photoReportage']);

              this.student_photo = [{ "imageUrl": this.students['url'] }]
              // const storageRef = this.firebaseStorageService.referenciaCloudStorage(this.students['primary_photo']);
              // storageRef.getDownloadURL().subscribe(downloadURL => {
              //   this.student_photo = [{"imageUrl":downloadURL}]
              // });
              this.creation_date = this.students.creation_date;
              this.modification_date = this.students.modification_date;
              //           this.studentsList = res;


              this.showStudentPhotosProgressBar2 = false
            },
              console.error
            );
        }
        else {
          this.isNew = true;
        }
      } else {
        this.isList = true;
        // params['reportage_id'] = localStorage.getItem('reportage_filter')
        // this.updateReportagesTable(params)
        // this.updatePaginator(params);
        // this.clearFilterButtonState();
      }

      
      //this.codeId = params['id'];
    });
  }

  selectFile(event, type) {
    if (type == 'primary') {
      this.selectedFiles = event.target.files;
    }
    else {
      this.selectedSecondaryFiles = event.target.files;
    }

  }


  goTo(reportageID: string) {
    this.router.navigateByUrl(`reportage-details/${reportageID}`);

  }


  deletePhoto(photo_id: String) {

    this.routeSub = this.route.params.subscribe(data => {
      let params = {}
      params['photo_id'] = photo_id

      this.dataService.deleteReportagePhoto(params).subscribe(res => {
        if (res == 'ok') {
          this.translate.get('alerts.photo_deleted').subscribe((res: string) => {
            this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000 })
            this.router.navigateByUrl(`reportage-details`);
            var p = {};
            p['page'] = 1
            p['size'] = this.pageSize
            p['search'] = '';
            p['role'] = '';
            p['reportage_id'] = localStorage.getItem('reportage_filter')
            this.updateReportagesTable(p)
            this.updatePaginator(p);
          })
          return false;
        }
        else {
          this.translate.get('alerts.delete_photo_error').subscribe((res: string) => {
            this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
          })
        }
      })
    })
  }


  applyFilter(reportageID: any) {

    // Auto enables after updateReportagesTable() gets API call response.
    this.filterForm.disable();

    if (reportageID) {
      localStorage.setItem("reportage_filter", this.filterForm.controls["reportages"].value);
    }

    this.showStudentPhotosProgressBar = true;
    // const filterValue = (event.target as HTMLInputElement).value;
    // this.dataSource.filter = filterValue.trim().toLowerCase();
    var params = {};
    params['page'] = 1
    params['size'] = this.pageSize
    params['reportage_id'] = this.filterForm.controls["reportages"].value;

    // params['line_id'] = this.filterForm.controls["lines"].value;


    // TODO Review issue fix where period and grade weren't showing (ERROR TypeError: Cannot read property 'value' of null)
    params['search'] = <HTMLInputElement>document.getElementById("input") == null ? null : (<HTMLInputElement>document.getElementById("input")).value;


    // this.dataService.getStudentphotos(params).pipe(
    //   map((tableData: Student) => this.dataSource = tableData)
    // ).subscribe(() => this.showStudentPhotosProgressBar = false)

    this.updateReportagesTable(params)

    // this.dataService.getTotalStudents(params).pipe(
    //   map((totalItems) => this.totalItems = totalItems)
    // ).subscribe()

    this.updatePaginator(params);

    this.clearFilterButtonState();

  }

  clearFilters() {

    localStorage.removeItem("reportage_filter");
    localStorage.removeItem("stage_filter");
    localStorage.removeItem("grade_filter");

    this.filterForm.controls["reportages"].setValue('')
    this.filterForm.controls["stages"].setValue('')
    this.filterForm.controls["grades"].setValue('')

    this.stages = []
    this.grades = []

    this.dataSource = <any>[]

    // this.applyFilter(null)

  }

  newStudent() {
    this.router.navigateByUrl(`studentphoto/new`);
  }

  saveReportagephoto() {
    var params = {};
    params['id'] = this.studentForm.controls["id"].value;
    params['name'] = this.studentForm.controls["name"].value;
    params['reportage_id'] = this.studentForm.controls["reportage_id"].value;


    if (params['name'] == '') {
      this.translate.get('alerts.name_required').subscribe((res: string) => {
        this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
      })
      return false;
    }


    if (this.selectedFiles) {
      const filePath = 'reportages/' + params['reportage_id'] + '/'+ params['name'] + '_original';
      const storageRef = this.firebaseStorageService.referenciaCloudStorage(filePath);
      const uploadTask = this.firebaseStorageService.tareaCloudStorage(filePath, this.selectedFiles[0]);
      uploadTask.snapshotChanges().pipe(
        finalize(() => {
          params['url'] = filePath.slice(0, -9)

          params['url2'] = ''
          this.dataService.uploadReportageImages(params).subscribe(data => {
            if (data == '') {
              this.router.navigateByUrl(`reportage-details`);
            }
            else {
              this.translate.get('alerts.save_photo_error').subscribe((res: string) => {
                this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
              })
            }
          })

        })
      ).subscribe();
    }
    else {
      this.route.params.subscribe(r => {
        if (r.id == 'new') {
          this.translate.get('alerts.photo_required').subscribe((res: string) => {
            this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
          })
          return false;
        }
        else {
          params['url'] = '';

          params['url2'] = ''
          this.dataService.uploadReportageImages(params).subscribe(data => {
            if (data == '') {
              this.router.navigateByUrl(`reportage-details`);
            }
            else {
              this.translate.get('alerts.save_photo_error').subscribe((res: string) => {
                this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
              })
            }
          })
        }
      })

    }
  }

  onPaginateChange(event: PageEvent) {

    this.showStudentPhotosProgressBar = true;

    this.pageSize = event.pageSize
    var params = {};

    params['page'] = event.pageIndex + 1
    params['size'] = this.pageSize
    params['role'] = ''
    params['reportage_id'] = this.filterForm.controls["reportages"].value;

    params['search'] = (<HTMLInputElement>document.getElementById("input")).value;
    

    this.updateReportagesTable(params);
    // this.updatePaginator(params);

    // let page = event.pageIndex;
    // let size = event.pageSize;

    // page = page + 1;

    // var params={};
    // params['catalogue'] = this.filterForm.controls["catalogue"].value;
    // params['theme'] = this.filterForm.controls["theme"].value;
    // params['page'] = page;
    // params['size'] = size;
    // this.dataService.getSchools(params).subscribe(reportages => {
    //   this.reportages = reportages;
    //   this.dataSource.data = this.reportages;

    //   // this.dataSource.filter = '';


    // });
  }

}
export class Reportage {
  constructor(
    public name: string,
    public reportage: string,
    public id: string,
  ) { }
}


// export interface TableData{
//   items: Student[];
//   meta:{
//     totalSchools: number;
//     itemCount: number;
//     itemsPerPage: number;
//     totalPages: number;
//     currentPage: number;
//   },
//   links:{
//     first: string;
//     previous: string;
//     next: string;
//     last: string;
//   }
// }
